import { memo } from 'react'
import CloseIcon from '~/icons/close-icon'
import type { VoucherInfo } from '~/hooks/type'
import { formatSingleDate, getTranslation } from '~/lib'

interface VoucherInfoProps {
  data: VoucherInfo
  onClose: () => void
  isOpen?: boolean
  locale: any
}

const VoucherInfoModal = ({ isOpen, data, onClose, locale }: VoucherInfoProps) => {
  if (!isOpen) return null
  const t = getTranslation(locale)
  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
      <div className="rounded-lg bg-white px-4 py-6 shadow-lg sm:w-fit md:w-[730px]">
        <div className={'flex items-center justify-between py-4'}>
          <div className={'text-[24px] font-medium'}>{t('voucher_detail.label')}</div>
          <button
            onClick={() => {
              onClose()
            }}
          >
            <CloseIcon></CloseIcon>
          </button>
        </div>
        <hr />
        <div className={'items-center justify-between py-4'}>
          <div className={'mb-2 text-[18px] font-medium'}>
            {t('booking.voucher_code')}: {data.voucherCode}
          </div>
          <div className={'text-[14px] text-[#666B74]'}>
            {t('voucher_detail.expire_date')}
            {formatSingleDate(new Date(data.activeDate)) +
              ' - ' +
              formatSingleDate(new Date(data.expiredDate))}
          </div>
        </div>
        {data.applyCondition && (
          <>
            <hr />
            <div className={'items-center justify-between py-4'}>
              <div className={'mb-2 text-[18px] font-medium'}>
                {t('voucher_detail.apply_condition')}
              </div>
              <p className={'whitespace-pre-line text-[14px] text-[#666B74]'}>
                {data.applyCondition}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function arePropsEqual(prevProps: VoucherInfoProps, nextProps: VoucherInfoProps) {
  return prevProps.isOpen === nextProps.isOpen && prevProps.data === nextProps.data
}

export default memo(VoucherInfoModal, arePropsEqual)
